import { render, staticRenderFns } from "./userDeptArry.vue?vue&type=template&id=79606da1&scoped=true"
import script from "./userDeptArry.vue?vue&type=script&lang=js"
export * from "./userDeptArry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79606da1",
  null
  
)

export default component.exports